<template>
  <section :class="$style.joinWhy">
    <div class="container">
      <JoinHeading
        :level="4"
        class="mb-7 text-center"
      >
        {{ $t('join.section.partners.title') }}
      </JoinHeading>
    </div>

    <PageCollectionCarousel align="center">
      <div>
        <div
          v-for="(imageRows, index) in PartnerImages.media"
          :key="`media-${index}`"
          :class="$style.partners"
          class="d-flex flex-wrap justify-content-center"
          :style="{
            flex: `0 0 ${(imageWidth + imageGap) * (imageRows.length)}px`,
            gap: `${imageGap}px`,
          }"
        >
          <img
            v-for="image in imageRows"
            :key="image"
            :src="image"
            :class="$style.item"
          >
        </div>

        <div
          v-for="(imageRows, index) in PartnerImages.social"
          :key="`social-${index}`"
          :class="$style.partners"
          class="d-flex flex-wrap justify-content-center"
          :style="{
            flex: `0 0 ${(imageWidth + imageGap) * (imageRows.length)}px`,
            gap: `${imageGap}px`,
          }"
        >
          <img
            v-for="image in imageRows"
            :key="image"
            :src="image"
            :class="$style.item"
          >
        </div>
      </div>
    </PageCollectionCarousel>
  </section>
</template>

<script lang="ts">
import PageCollectionCarousel from '@/scripts/pages/onepager/components/PageCollectionCarousel.ts.vue';
import { JoinBaseComponent } from '../common/JoinBaseComponent';
import JoinHeading from '../common/JoinHeading.ts.vue';
import { PartnerImages } from '../assets/media';

export default JoinBaseComponent.extend({
  components: {
    JoinHeading,
    PageCollectionCarousel,
  },
  data() {
    return {
      PartnerImages,
      imageWidth: 200,
      imageGap: 64,
    };
  },
});
</script>

<style module lang="scss">
$width: 200px;

.partners {
  margin-top: 3rem;
  margin-bottom: 8rem;
}

.item {
  min-width: $width;
  max-width: $width;
  width: $width;
  object-fit: contain;
  object-position: center;
}
</style>
